import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
import { UserProvider } from '../user/user';

@Injectable()
export class SettingsProvider {

  //Show or hide walkthrouh
  private theme: BehaviorSubject<String>;
  color: any;
  constructor(public user: UserProvider) {
    this.user.getuserdetails().then((res: any) => {
      this.color = res.theme;
    })
    if (this.color == 'dark-theme') {
      this.theme = new BehaviorSubject('dark-theme');
    }
    else {
      this.theme = new BehaviorSubject('light-theme');
    }
  }

  setActiveTheme(val) {
    this.theme.next(val);
  }

  getActiveTheme() {
    return this.theme.asObservable();
  }
}


// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts